module.exports = __webpack_public_path__ + "img/repguide-wartung-screenshots-checks.62c01581.jpg";